<template>
  <div>
    <isrs-country-mapping-form
      v-if="countryContactsMappingMap"
      @change="countryContactsMappingChanged"
      :countries-selected="countryContactsMappingMap"
      :contacts="contacts"
    ></isrs-country-mapping-form>

    <v-btn @click.native="countryContactMappingsUpdated()" block color="success" v-if="showSaveButton">Save</v-btn>
  </div>
</template>

<script>

  import { mapState, mapGetters, mapActions } from 'vuex'

  import DataService from '../../services/data'
  import IsrsCountryMappingForm from '../../components/IsrsCountryMappingForm.vue'

  export default {
    components: {IsrsCountryMappingForm},
    data () {
      return {
        showSaveButton: false,
        changedCountryContactMappings: {}
      }
    },

    created () {
      this.dataService = new DataService(
        this.profile, 
        this.$store.state.tokens
      )
    },

    computed: {
      ...mapGetters('returnShopPortal', [
        'countryContactsMappingMap',
        'contacts'
      ]),
    },

    methods: {
      ...mapActions('returnShopPortal', [
        'saveCountryContactMappings'
      ]),

      countryContactsMappingChanged(val) {
        this.changedCountryContactMappings = val
        this.showSaveButton = true
      },

      countryContactMappingsUpdated() {
        return this.saveCountryContactMappings(this.changedCountryContactMappings)
          .then(() => {
            this.showSaveButton = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Mappings.vue?62b50ba9